import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "facebook",
  "use": "facebook-usage",
  "viewBox": "0 0 33 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 33 32\" id=\"facebook\">\n<title>facebook</title>\n<path d=\"M30.49 0h-28.48c-0.98 0-1.78 0.8-1.78 1.78v28.44c0 0.98 0.8 1.78 1.78 1.78h14.26v-11.98h-4v-5.020h3.98v-2.22c0-1.68 0.1-3.46 0.42-4.28 0.44-1.1 1.020-2.1 2.14-2.78s2.68-1.020 4.68-1.020c1.080 0 1.52 0 2.78 0.18v4.38c-0.92 0-1.4-0.040-2.22-0.020-1.4 0.020-1.96-0.18-2.58 0.72-0.38 0.56-0.26 1.32-0.26 2.34 0 1.2 0.060 2.68 0.060 2.68h5l-1 5.040h-4v11.98h9.22c0.98 0 1.78-1.060 1.78-2.040v-28.18c0-0.98-0.8-1.78-1.78-1.78z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol